import { jsx, jsxs } from "react/jsx-runtime";
import { cloneElement } from "react";
import assert from "assert";
import { Box } from "../Box/Box.mjs";
import { Text } from "../Text/Text.mjs";
import { ButtonIcon } from "../ButtonIcon/ButtonIcon.mjs";
import "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconClose } from "../icons/IconClose/IconClose.mjs";
import { clearGutter } from "./Tag.css.mjs";
const textSize = "standard";
const Tag = ({
  onClear,
  clearLabel = "Clear",
  data,
  id,
  icon,
  children,
  ...restProps
}) => {
  assert(
    typeof children === "undefined" || typeof children === "string",
    "Tag may only contain a string"
  );
  assert(
    !icon || icon.props.size === void 0 || icon.props.tone === void 0,
    "Icons cannot set the 'size' or 'tone' prop when passed to a Tag component"
  );
  return /* @__PURE__ */ jsx(Box, { id, display: "flex", ...buildDataAttributes({ data, validateRestProps: restProps }), children: /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      minWidth: 0,
      alignItems: "center",
      background: "neutralLight",
      paddingY: onClear ? void 0 : "xxsmall",
      paddingLeft: icon ? "xsmall" : "small",
      paddingRight: onClear ? void 0 : "small",
      borderRadius: "full",
      children: [
        icon ? /* @__PURE__ */ jsx(Box, { paddingRight: "xxsmall", children: cloneElement(icon, { size: textSize }) }) : null,
        /* @__PURE__ */ jsx(Box, { minWidth: 0, title: children, children: /* @__PURE__ */ jsx(Text, { size: textSize, baseline: false, maxLines: 1, children }) }),
        onClear ? /* @__PURE__ */ jsx(Box, { flexShrink: 0, display: "flex", className: clearGutter, children: /* @__PURE__ */ jsx(
          ButtonIcon,
          {
            id: id ? `${id}-clear` : void 0,
            icon: /* @__PURE__ */ jsx(IconClose, {}),
            label: clearLabel,
            tone: "secondary",
            variant: "transparent",
            bleed: false,
            onClick: onClear
          }
        ) }) : null
      ]
    }
  ) });
};
export {
  Tag
};
